import React from 'react'
import { Contacts } from './Contacts'
import './Contacts.scss'

const ContactsPage = () => {
    return (
        <div className='contacts-page'>
            <Contacts fullScreen={true} /></div>
    )
}

export default ContactsPage;